import { ArnValidI18nConfig } from '@arianee/arn-types';

export type ArnI18nConfig = Partial<ArnValidI18nConfig>;

export class ArnHttpI18nConfig implements ArnValidI18nConfig {
  constructor(
    readonly url: string,
    readonly defaultLang: string,
    readonly lang: string[]
  ) {}
}
